/**
 * @generated SignedSource<<4b546303b9d04716e146d237fe8c7851>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type featureFlags_viewer$data = {
  readonly component: string | null;
  readonly id: string;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly company: {
    readonly id: string;
  } | null;
  readonly availableFeatureFlags: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly missionControlData: {
    readonly id: string;
    readonly companies: ReadonlyArray<{
      readonly id: string;
      readonly companyId: number | null;
      readonly name: string | null;
      readonly tier: TierType | null;
      readonly forecastDemo: boolean | null;
      readonly contactEmail: string | null;
      readonly accessBlocked: boolean | null;
    } | null> | null;
    readonly availableFeatures: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null;
      readonly key: string | null;
      readonly color: string | null;
      readonly team: string | null;
      readonly description: string | null;
      readonly rolledOut: boolean | null;
      readonly rolledOutDate: string | null;
      readonly cleanedUp: boolean | null;
      readonly expectedRollOutDate: string | null;
      readonly type: string | null;
      readonly companies: ReadonlyArray<{
        readonly id: string;
        readonly companyId: string;
        readonly name: string | null;
        readonly timestamp: string | null;
      } | null> | null;
      readonly persons: ReadonlyArray<{
        readonly id: string;
        readonly personId: string;
        readonly companyId: string;
        readonly companyName: string | null;
        readonly name: string | null;
        readonly email: string | null;
        readonly timestamp: string | null;
      } | null> | null;
      readonly personsOptedOut: ReadonlyArray<{
        readonly id: string;
        readonly companyId: string;
        readonly companyName: string | null;
        readonly name: string | null;
        readonly email: string | null;
      } | null> | null;
    } | null> | null;
    readonly forecastPersons: ReadonlyArray<{
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly email: string | null;
    } | null> | null;
    readonly otherPersons: ReadonlyArray<{
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly email: string | null;
      readonly companyName: string | null;
      readonly companyId: string;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"missionControlHeader_viewer">;
  readonly " $fragmentType": "featureFlags_viewer";
};
export type featureFlags_viewer$key = {
  readonly " $data"?: featureFlags_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"featureFlags_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "featureFlags_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "control_feature_flags"
        }
      ],
      "kind": "ScalarField",
      "name": "component",
      "storageKey": "component(name:\"control_feature_flags\")"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureFlag",
      "kind": "LinkedField",
      "name": "availableFeatureFlags",
      "plural": true,
      "selections": [
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "missionControlHeader_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlCompanyType",
          "kind": "LinkedField",
          "name": "companies",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tier",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastDemo",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "contactEmail",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accessBlocked",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailableFeaturesType",
          "kind": "LinkedField",
          "name": "availableFeatures",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v5/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "team",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rolledOut",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rolledOutDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cleanedUp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expectedRollOutDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyFeatureType",
              "kind": "LinkedField",
              "name": "companies",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonFeatureType",
              "kind": "LinkedField",
              "name": "persons",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "personId",
                  "storageKey": null
                },
                (v4/*: any*/),
                (v7/*: any*/),
                (v5/*: any*/),
                (v8/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonFeatureType",
              "kind": "LinkedField",
              "name": "personsOptedOut",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v4/*: any*/),
                (v7/*: any*/),
                (v5/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlImpersonatePersonType",
          "kind": "LinkedField",
          "name": "forecastPersons",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v8/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlImpersonatePersonType",
          "kind": "LinkedField",
          "name": "otherPersons",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v8/*: any*/),
            (v7/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "a4dee01c4e5fbc70295d9be096210c98";

export default node;
